export default "__VITE_ASSET__f0526500__"